module.exports = __webpack_public_path__ + "assets/img/TabBar_Chat_Selected.49506d88.svg";